import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { DataTable, IDataTableColumn } from '../../components/common/DataTable';
import { eBaseActionStatus } from '../../context/base/eBaseActionStatus';
import { BlockCard } from '../../components/container';
import { Button, ButtonCancel, ButtonLink, ButtonSave, LoadingTable, ModalBody, ModalDraggable, ModalFooter, ModalHeader } from '../../components/base';
import { BannerConfigModel } from '../../context/models/banners/BannerConfigModel';
import { BaseShowDetail } from '../../context/base/BaseShowDetail';
import { actions } from '../../context/stores/rootActions';
import { AppState } from '../../context/stores/rootReducers';
import { useLookupBannerPosition } from '../../components/shared/hoc-banner-position/useLookupBannerPosition';
import { useLookupProductCategory } from '../../components/shared/hoc-product-category/useLookupProductCategory';
import { useForm } from 'react-hook-form';

type IBannerConfigDetailModalProps = {
	isShow: boolean;
	title: string;
	detailModel?: BannerConfigModel;
	isSaving: boolean | false;
	onClose: () => void;
	onSubmit: (data: BannerConfigModel) => void;
};
const BannerConfigModal = (props: IBannerConfigDetailModalProps) => {
	const dispatch = useDispatch();

	const { isShow, title, detailModel, onSubmit, onClose, isSaving } = props;
	// const isAddMode = !detailModel;

	const { status, allProductCategorys, selectedIds } = useSelector((state: AppState) => state.productCategory);

	const dataSources = useMemo(() => {
		return allProductCategorys.sort((a, b) => a.id - b.id);
	}, [allProductCategorys]);

	const {
		handleSubmit,
	} = useForm<BannerConfigModel>({
	});

	const onSubmitHandler = (values: BannerConfigModel) => {
		const data = { ...values};
		onSubmit(data);
	};

	const handleReloadDataWithFilter = useCallback(
		() => {
			dispatch(actions.productCategory.getAllRequest());
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const { product_category_all } = useLookupProductCategory();

	const onChangeSelectedIds = (ids: number[]) => {
		dispatch(actions.productCategory.changeSelectedIds(ids));
	};

	useEffect(() => {
		handleReloadDataWithFilter();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (status == eBaseActionStatus.reload) handleReloadDataWithFilter();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status]);

	const columns = useMemo((): IDataTableColumn<any>[] => {
		return [
			{
				accessorKey: 'id',
				header: 'Trang hiển thị',
				minSize: 150,
				cell: ({ getValue }) => {
					const val = getValue() as number;
					const cat = product_category_all.find((c: any) => c.id === val);
					return <span className='font-medium'>{cat ? cat.name : val}</span>;
				}
			}
		];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [product_category_all]);

	return (
		<>
			<ModalDraggable show={isShow} sizeClass='md' type='primary' onClose={onClose}>
				<ModalHeader classDragg={true} title={title} onClose={() => onClose()} />
				<ModalBody>
					<div className='w-full'>
						<BlockCard>
							{status === eBaseActionStatus.loading && <LoadingTable />}
							{status !== eBaseActionStatus.loading && (
								<DataTable
									data={dataSources}
									columns={columns}
									isLoading={status !== eBaseActionStatus.complete}
									enableRowSelection
									rowSelection={selectedIds.reduce((acc, id) => ({ ...acc, [String(id)]: true }), {})}
									onRowSelectionChange={(selection) => {
										onChangeSelectedIds(Object.keys(selection).filter(k => selection[k]).map(Number));
									}}
									enablePagination
									totalRecords={dataSources.length}
									enableGlobalFilter
									toolbar={{ isShowSearch: true, searchPlaceholder: `Tìm danh mục...` }}
									onRefresh={handleReloadDataWithFilter}
								/>
							)}
						</BlockCard>
					</div>
				</ModalBody>
				<ModalFooter>
					<ButtonCancel onClick={onClose} isDisabled={isSaving} />
					<ButtonSave
						type='button'
						isLoading={isSaving}
						isDisabled={isSaving}	
						onClick={handleSubmit(onSubmitHandler as any)}
						// text={`${!isAddMode ? 'Cập nhật' : 'Thêm mới'}`}
					/>
				</ModalFooter>
			</ModalDraggable>
		</>
	);
};

export default BannerConfigModal;
